var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    메인2222\n    "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("about")]),_c('pre',[_vm._v("\n\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }